import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common'
import { LoaderService } from '../../services/loader.service';
import { environment } from '../../../environments/environment';

import 'rxjs/add/operator/toPromise';
import { ApiService, AuthService, ChatService } from 'angular-lib';

@Component({
    selector: 'ez-login',
    template: require('./login.component.html'),
    styles: [require('./login.component.less')]
})

export class LoginComponent {
    public login: string = '';
    public password: string = '';
    public loginFailedMessage: string = '';

    constructor(
        private apiService: ApiService,
        private router: Router,
        private location: Location,
        private loaderService: LoaderService,
        private chatService: ChatService,
        private activatedRoute: ActivatedRoute,
    ) {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params.jwt !== undefined) {
                AuthService.login(params.jwt);
                this.router.navigate(['member/home']);
            }
        });
    }

    public submit(): void {
        this.loginFailedMessage = '';
        this.loaderService.show();
        this.apiService.auth({
            login: this.login,
            password: this.password,
            channel: environment.channelId
        })
            .subscribe(
                json => {
                    AuthService.login(json.jwt);
                    this.chatService.refreshUnreadMessageBubbleState();
                    this.apiService.user()
                        .subscribe(
                            user => {
                                console.log('LOGGED', user);
                                // if user doesn't has yet define his own password
                                if (user.hasGeneratedPassword) {
                                    console.log('Pas de mot de passe detecté');
                                    this.router.navigate(['member/account/password']);
                                } else {
                                    this.router.navigate(['member/home']);
                                }
                                this.loaderService.hide();
                            },
                            e => {
                                this.loaderService.hide();
                            }
                        )
                },
                e => {
                    this.loaderService.hide();
                    if (e.status === 401) {
                        let response = e.error;
                        this.loginFailedMessage = response.message;
                    }
                }
            );
    };

    public fbSignedIn(accessToken) {
        this.apiService.auth({
            FBAuth: {accessToken: accessToken},
        }).subscribe(json => {
                AuthService.login(json.jwt);
                this.chatService.refreshUnreadMessageBubbleState();
                this.router.navigate(['member/home']);
            },
            e => {
                console.log('fbSignedIn error', e);
            }
        );
    };

    public back() {
        this.location.back();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/login/login.component.ts